import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { IInvoiceDealValidationParams } from './types';

export const fetchInvoiceDealValidation: AsyncThunk<void, IInvoiceDealValidationParams, ThunkAPI> =
  createAsyncThunk(
    'invoiceDealValidation/fetch',
    async (data, thunk) => {
      if (!isFeatureEnabled(Features.PlgExternal3)) {
        thunk.dispatch({
          type: 'DO_NOTHING'
        });
        return;
      }
      try {
        return await basicApiAsyncThunkCreator<void, null>({
          endpoint: `crm/account/${data.accountIdOrHubspotCompanyId}/validate/deal/${data.hubspotDealId}`,
          microservice: SERVICES.USERS_SERVICE,
          authenticated: true,
          method: HttpMethods.Post,
          contentType: 'application/json'
        })(null, thunk);
      } catch (err) {
        return thunk.rejectWithValue(err);
      }
    }
  );
